module.exports = __webpack_public_path__ + "img/gbr.d3ddd602.svg";